/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-organism-antibiotic-susceptibility.reducer';

export const PatientOrganismAntibioticSusceptibilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientOrganismAntibioticSusceptibilityEntity = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientOrganismAntibioticSusceptibilityDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.detail.title">
            PatientOrganismAntibioticSusceptibility
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.id}</dd>
          <dt>
            <span id="zoneOfInhibition">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.zoneOfInhibition">
                Zone Of Inhibition
              </Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.zoneOfInhibition}</dd>
          <dt>
            <span id="mic">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.mic">Mic</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.mic}</dd>
          <dt>
            <span id="mbc">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.mbc">Mbc</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.mbc}</dd>
          <dt>
            <span id="testDate">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.testDate">Test Date</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.testDate}</dd>
          <dt>
            <span id="virulenceFactors">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.virulenceFactors">
                Virulence Factors
              </Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.virulenceFactors}</dd>
          <dt>
            <span id="resistanceMechanisms">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.resistanceMechanisms">
                Resistance Mechanisms
              </Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.resistanceMechanisms}</dd>
          <dt>
            <span id="morphology">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.morphology">Morphology</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.morphology}</dd>
          <dt>
            <span id="growthConditions">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.growthConditions">
                Growth Conditions
              </Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.growthConditions}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.timestampEntry}</dd>
          <dt>
            <span id="recommended">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.recommended">Recommended</Translate>
            </span>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.recommended ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.patientLabTestItem">
              Patient Lab Test Item
            </Translate>
          </dt>
          <dd>
            {patientOrganismAntibioticSusceptibilityEntity.patientLabTestItem
              ? patientOrganismAntibioticSusceptibilityEntity.patientLabTestItem.id
              : ''}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.organism">Organism</Translate>
          </dt>
          <dd>{patientOrganismAntibioticSusceptibilityEntity.organism ? patientOrganismAntibioticSusceptibilityEntity.organism.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.antibiotic">Antibiotic</Translate>
          </dt>
          <dd>
            {patientOrganismAntibioticSusceptibilityEntity.antibiotic ? patientOrganismAntibioticSusceptibilityEntity.antibiotic.id : ''}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.sensitivity">Sensitivity</Translate>
          </dt>
          <dd>
            {patientOrganismAntibioticSusceptibilityEntity.sensitivity ? patientOrganismAntibioticSusceptibilityEntity.sensitivity.id : ''}
          </dd>
        </dl>
        <Button tag={Link} to="/patient-organism-antibiotic-susceptibility" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/patient-organism-antibiotic-susceptibility/${patientOrganismAntibioticSusceptibilityEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientOrganismAntibioticSusceptibilityDetail;
